<template>
    <div class="px-3">
        <router-link :to="to" :class="fullClassName">
            <div class="flex items-center justify-center lg:justify-start w-full">
                <i :class="iconFullClassName"></i>
                <span class="hidden lg:block w-full">
                    <slot></slot>
                </span>
            </div>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: {
            section: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default: 'fas fa-circle',
            },
            to: {
                type: Object,
                default() {
                    return {};
                }
            },
            iconClassName: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_link_icon;
                }
            },
            activeIconClassName: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_link_icon_active;
                }
            },
            className: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_link;
                }
            },
            activeClassName: {
                type: String,
                default() {
                    return this.$spa.css.layout.sidebar_link_active;
                }
            }
        },
        computed: {
            fullClassName() {
                return [
                    this.className,
                    this.isActive && this.activeClassName
                ];
            },
            iconFullClassName() {
                return [
                    this.icon,
                    this.iconClassName,
                    this.isActive && this.activeIconClassName
                ] 
            },
            isActive()
            {
                return this.section && this.section === this.$store.state.sidebar.section;
            }
        }
    }
</script>
